module.exports = __webpack_public_path__ + "static/media/star_2_hover.e3ec6848.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars/star_2_hover.svg
// module id = 334
// module chunks = 0